import { throttle } from 'throttle-debounce'

const truncateText = () => {

  const wrapper = document.querySelector('[data-collection-tags-wrapper]');
  const filters = document.querySelector('[data-collection-tags-filters]');
  if (filters.innerHTML === '') {
    wrapper.classList.add('hide-filters');
  }

  // Read more toggle 
  let truncated = true;
  const container = document.querySelector('.submenu');
  if (!container) return;

  const content = container.querySelector('[data-description]');
  const button = document.querySelector('.read-more');

  if (!content) return;

  // replace specified word within text
  const replaceFrom = (string, search, replace, pos) => {
    pos -= 1
    let splitString = string.split(search)
    if (splitString[pos]) {
      let length = 0
      // work out the length of the previous strings
      if (pos > 0) {
        let i = 0;
        while (i < pos) {
          length += splitString[i].length + search.length;
          i++;
        }
      }
      // rejoin the word back together
      splitString = splitString.join(search)
      // search and replace for the word after other occurrences 
      splitString = splitString.substr(0, length) + splitString.substr(length).replace(search, replace);
    } else {
      splitString = splitString.join(search)
    }
    return splitString;
  }

  // add ellipsis into the content
  const injectEllipsis = (content) => {
    // all this to work out the last word on the second line
    // then get position and move the ellipsis to display at the correct position 
    const linesToShow = 2;
    let foundIt = false;
    // if resizing remove previous setups
    const prevEllips = content.querySelector('.lastWordEllips');
    if (prevEllips) {      
      content.innerHTML = content.innerHTML.replace(prevEllips.outerHTML, '')
    }
    const prevEllipsFull = content.querySelector('.lastWordFull');
    if (prevEllipsFull) {
      content.innerHTML = content.innerHTML.replace(prevEllipsFull.outerHTML, prevEllipsFull.innerText)
    }
    let originalHTML = content.innerHTML;
    content.innerHTML = '<p><span>'+content.innerText.replace(/\n/g,'</span><br/><span>').replace(/ /g,'</span> <span>')+'</span></p>'
    const words = content.querySelectorAll('span');
    let line = 0;
    let currentLineTop = 0
    const roughPosCounter = []
    let lastWord
    for (let i=0; i < words.length ; i++) {
      if (currentLineTop !== words[i].offsetTop) {
        // we're on a new line (different top positions)
        if (line === linesToShow) {
          // if we're on the line we want to display
          // grab the previous word (i.e. last word from previous line)
          // inject the ellipsis to replace the last 3 chars of the final word
          const theLastWord = lastWord.trim();
          const partialWord = theLastWord.substring(0, theLastWord.length-3);
          originalHTML = replaceFrom(originalHTML, `${theLastWord}`,`<span class="lastWordEllips">${partialWord}...</span><span class="lastWordFull hide">${theLastWord}</span>`, roughPosCounter[lastWord])
          content.innerHTML = originalHTML;
          foundIt = true;
          break
        }
        currentLineTop = words[i].offsetTop
        line++;
      }
      // keep a reference to the previous word
      if (words[i].innerText.length >= 1) {
        lastWord = words[i].innerText;
      }
      roughPosCounter[words[i].innerText] = (roughPosCounter[words[i].innerText] || 0) + 1;
    }

    // failsafe we've gone through the list of words
    // and not found the last word - set the content back to the original
    if (!foundIt) {
      content.innerHTML = originalHTML;
    }
  }
  injectEllipsis(content);
  window.addEventListener('resize', throttle(500, false, () => {
    const content = document.querySelector('.submenu [data-description]');
    injectEllipsis(content);
  }));

  button.addEventListener('click', function() {    
    const lastWordEllips = document.querySelector('.lastWordEllips');
    const lastWord = document.querySelector('.lastWordFull');
    if (truncated) {
      content.classList.remove('collection-header-text');
      content.classList.add('collection-header-text-full');
      lastWordEllips?.classList?.add('hide');
      lastWord?.classList?.remove('hide');
      button.innerHTML = 'Read less';
      truncated = false;
    } else {
      content.classList.remove('collection-header-text-full');
      content.classList.add('collection-header-text');
      lastWordEllips?.classList?.remove('hide');
      lastWord?.classList?.add('hide');
      button.innerHTML = 'Read more';
      document.querySelector('.collection-accordion h1').scrollIntoView({ behavior: 'smooth', block: 'end'});
      truncated = true;
    }
    container.classList.toggle('truncate');
  });
}

export default truncateText;

